<template>
    <app-data-table
        :fields="fields"
        :items="data.data"
        @sort="onSort"
        :current-page="data.current_page"
        :last-page="data.last_page"
        :from="data.from"
        :to="data.to"
        :total="data.total"
        :per-page="data.per_page"
        :on-change-page="onChangePage"
    >

        <template slot="created_at" slot-scope="{ item }">
            {{ item.created_at | datetime }}
        </template>
        
        <template slot="content" slot-scope="{ item }">
                <div id="content" v-html="item.content">
                </div>
            </template>

        <template slot="photos" slot-scope="data">
            <b-button size="sm" v-if="!data.item._showDetails" :disabled="!data.item.notebook_photos.length" @click.stop="data.toggleDetails" variant="primary">Fotos <b-badge>{{ data.item.notebook_photos.length }}</b-badge></b-button>
            <b-button size="sm" v-else variant="danger" @click.stop="data.toggleDetails">Cerrar <b-badge>{{ data.item.notebook_photos.length }}</b-badge></b-button>
        </template>

        <template slot="row-details" slot-scope="data">
            <div class="d-flex justify-content-center">
                <div class="w-50">
                    <b-carousel id="carousel1"
                        style="text-shadow: 1px 1px 2px #333;"
                        controls
                        indicators
                        background="#ababab"
                        :interval="4000"
                        img-width="350px"
                        img-height="200px"
                    >
                        <b-carousel-slide v-for="photo in data.item.notebook_photos" img-height="200" :key="photo.id" :img-src="photo.photo_url"
                    ></b-carousel-slide>
                    </b-carousel>
                </div>
            </div>
        </template>

    </app-data-table>
</template>
<script>
    import fields from './fields';
    export default {
        data(){
            return {
                fields: fields
            }
        },
        props: {
            data: {
                required: true
            },
            onChangePage: {
                type: Function,
                required: true
            }
        },
        methods: {
            onSort(ctx) {
                this.$emit('sort', ctx);
            },
        }
    }
</script>
<style>
#content {
    font-size: 17px;
}
</style>
